import App from '@/app/app'
import '@/init'
// Versioned by the pnpm catalog rather than a CDN URL — see index.html.
import 'maplibre-gl/dist/maplibre-gl.css'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

// Auto-reload when lazy-loaded chunks fail after a deployment (stale hashes).
// { once: true } prevents infinite reload loops if the error persists.
window.addEventListener(
  'vite:preloadError',
  (e) => {
    e.preventDefault()
    window.location.reload()
  },
  { once: true },
)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
